import React, { Component } from "react";
import { connect } from "react-redux";

import actions from "actions";
import moment from "moment";
import { Link } from "react-router";
import { getGroupMaterials } from "../../actions/studygroups";

const { loadGroupMaterial, clearStudyGroupMaterial } = actions;

class StudyGroupUserMaterials extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      per_page: 5,
      search: "",
    };
  }

  componentDidMount() {
    this.loadGroupMaterials();
  }

  loadGroupMaterials = () =>
    this.props.loadStudyGroupMaterials({
      page: this.state.page,
      group_id: this.props.params.id,
      per_page: this.state.per_page,
      search: this.state.search,
    });

  getGroupMaterials = () =>
    this.props.getGroupMaterials({
      page: this.state.page,
      group_id: this.props.params.id,
      per_page: this.state.per_page,
      search: this.state.search,
    });

  setDefaultParams = () => {
    this.setState({
      page: 1,
      per_page: 5,
    });
  };

  componentWillUnmount() {
    this.props.clearStudyGroupMaterial();
  }

  handleLoadMore = () =>
    this.setState(
      (state) => ({ page: state.page + 1 }),
      this.loadGroupMaterials
    );

  handleQueryChange = (search, timeout = 500) => {
    this.setState({ search }, () => {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        this.getGroupMaterials();
        this.setDefaultParams();
      }, timeout);
    });
  };

  render() {
    const { materials, params } = this.props;

    const { search } = this.state;

    return (
      <div className="group-materials-container">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "12px",
          }}
        >
          <div className="container_admin_user">
            <div className="search_admin">
              <input id="search" type="submit" className="validate" />
              <label htmlFor="search">
                <i className="material-icons icon_search">search</i>
              </label>
              <input
                type="search"
                placeholder="Search"
                value={search}
                onChange={(e) => this.handleQueryChange(e.target.value)}
              />
              <i
                className="material-icons icon_close"
                onClick={() => this.handleQueryChange("")}
              >
                close
              </i>
            </div>
          </div>
          <Link to={`/groups/${params.id}/resources/new`}>
            <button className="button_link">Add new resource</button>
          </Link>
        </div>
        <div className="group-materials-list">
          {materials.data.map((m) => (
            <StudyGroupUserMaterialsFile key={m.id} {...m} />
          ))}
        </div>
        {materials.count !== materials.data.length && (
          <button
            className="group-materials-load-more"
            onClick={this.handleLoadMore}
          >
            Load more
          </button>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  materials: state.studygroups.materials,
});

const mapDispatchToProps = (dispatch) => ({
  loadStudyGroupMaterials: (payload) => dispatch(loadGroupMaterial(payload)),
  clearStudyGroupMaterial: (payload) =>
    dispatch(clearStudyGroupMaterial(payload)),
  getGroupMaterials: (payload) => dispatch(getGroupMaterials(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StudyGroupUserMaterials);

const StudyGroupUserMaterialsFile = ({
  title,
  file_url,
  user: { first_name, last_name },
  created_at,
}) => (
  <div className="group-materials-item">
    <div>
      <div>{moment(created_at).format("DD/MM/yyyy")}</div>
      <div className="group-materials-item-title">{title}</div>
      <div>
        Created by: {first_name} {last_name}
      </div>
    </div>
    <a href={file_url} target="_blank">
      <button className="button_link">View File</button>
    </a>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/StudyGroupsUser/StudyGroupUserMaterials.jsx